import * as React from 'react'

/** Debounce a fast-changing value so each keystroke isn't a request. */
export function useDebounced<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = React.useState<T>(value)

  React.useEffect(() => {
    const timer = setTimeout(
      () => setDebounced(value),
      Math.max(0, delayMs),
    )
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return debounced
}
